export default __webpack_public_path__ + "static/media/main2_l.ce689951.jpg";